import * as helper from "./../../../../../VX/View/Assets/Js/helper";
import {initImprint} from "../../../Assets/Js/VXImprint";
import {animation} from './Chat/animation';
import { videoHandler } from "./Video/videoHandler";
import { clickListener } from "./Listeners/clickListener";
import { scrollIntoView } from "./Helpers/scrollTo";
import { changeListener } from "./Listeners/changeListener";
import { checkUsername } from "./Form/checkUsername";
import { setSuggestion } from "./Form/setSuggestion";
import { submitListener } from "./Form/submitListener";
import { sendEmail } from "./EmailConfirmation/sendEmail";
import { setDatasets } from "./EmailConfirmation/setDatasets";
import {showVolumeUpButton} from "./Video/showVolumeUp";
import {toggleFloatingLogo} from "./Helpers/toggleFloatingLogo";
import {data} from "./Store/Data";
import {chatSimulation} from "./ChatSimulation/chatSimulation";
import {closeModal} from "./Modal/closeModal";
import {upgradeModal} from "./Modal/upgradeModal";

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const impressumLink = helper.$("#impressumlink");
	const datenschutzLink = helper.$("#datenschutzlink");
	const impressumLinkForm = helper.$("#terms_conditions_link");
	const datenschutzLinkForm = helper.$("#privacy_policy_link");
	initImprint(impressumLink, datenschutzLink);
	initImprint(impressumLinkForm, datenschutzLinkForm);

	if(data('chatsim').asBool()){
		chatSimulation();
		closeModal();
		upgradeModal();
	} else {
		animation();
		videoHandler();
		toggleFloatingLogo();
	}

	submitListener();

	clickListener('data-scroll-to-form', () => scrollIntoView('form-section') );
	clickListener('data-set-suggestion', setSuggestion);
	clickListener('data-send-email', (e) => sendEmail(e));
	clickListener('data-volume', showVolumeUpButton);
	//check if username does not exists
	changeListener('data-username-change', checkUsername);
	//prepare email confirmation view to show email domain according to the input
	changeListener('data-email-change', setDatasets);


});
